import { placesAdapterSelectors } from '../redux/slices/places';
import { createSelector } from 'reselect';

export const getAll = placesAdapterSelectors.selectAll;

export const getDeviceById = (id) => (state) =>
  placesAdapterSelectors.selectById(state, id);

export const currentWorkspacePlaces = createSelector(
  (state) => placesAdapterSelectors.selectAll(state),
  (state) => state.currentWorkspace.id,
  (places, currentWorkspace) =>
    places.filter((places) => places.workspaceId === currentWorkspace)
);
